<template>
    <div>

        <div class="content-header text-center">
            <h2>Select a Plan</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col text-center">
                    <h3>Analyze360: Segmentation reporting that fits your needs</h3>
                    <p class="lead">Analyze360 is the leading low-cost alternative to expensive consumer segmentation solutions. Our fast, accurate self-service platform allows you to transform your existing customer or marketing lists into advanced insights into consumer behavior, lifestyles, demographics, and trends in minutes! Our platform is backed by real consumer data on 220 million US households and individuals with hundreds of insights each.</p>
                </div>
            </div>
            <div class="row product-deck">
                <div class="col">
                    <div v-if="this.promoConfirm == '360FREE'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Single Report</h5>
                            <h5 class="h2 mb-0"><strong><del>$750</del></strong><br>
                                <strong><span class="text-success">$0</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>100% discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Unleash the power of segmentation! Get a customized report with a full segmentation, sociometric and psychographic analysis based on your data.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('freeItems', {title: 'Analyze360 2024 Single Report', price: '0', sku: 'A360_SNGL_FREE_23', mode: 'payment', remaining: '1', prospects: '1', subscription: 'single' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="this.promoConfirm == 'A360_SNGL_HALF_23'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Single Report</h5>
                            <h5 class="h2 mb-0"><strong><del>$750</del></strong><br>
                                <strong><span class="text-success">$375</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>50% discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Unleash the power of segmentation! Get a customized report with a full segmentation, sociometric and psychographic analysis based on your data.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Single Report', price: '375', sku: 'A360_SNGL_HALF_23', mode: 'payment', remaining: '1', prospects: '1', subscription: 'single' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Single Report</h5>
                            <h5 class="h2 mb-0"><strong>$750</strong></h5>
                            <hr>
                            <p class="card-text">Unleash the power of segmentation! Get a customized report with a full segmentation, sociometric and psychographic analysis based on your data.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Single Report', price: '750', sku: 'A360_SNGL_FULL_22', mode: 'payment', remaining: '1', prospects: '1', subscription: 'single' })">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div v-if="this.promoConfirm == 'LEADSCON_400'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Annual Access</h5>
                            <h5 class="h2 mb-0"><strong><del>$2,400/yr</del></strong><br>
                                <strong><span class="text-success">$167/mo</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>$400 discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Take your segmentation to the next level! With annual access you can get unlimited reports and basic support from our Analyze360 experts.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Annual Access', price: '2000', sku: 'LEADSCON_400', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'year'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="this.promoConfirm == 'A360_ANNUAL_HALF_23'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Annual Access</h5>
                            <h5 class="h2 mb-0"><strong><del>$2,400/yr</del></strong><br>
                                <strong><span class="text-success">$100/mo</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>50% discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Take your segmentation to the next level! With annual access you can get unlimited reports and basic support from our Analyze360 experts.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Annual Access', price: '1200', sku: 'A360_ANNUAL_HALF_23', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'year'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Annual Access</h5>
                            <h5 class="h2 mb-0"><strong>$2,400</strong></h5>
                            <p class="mb-3"><small>per year,<br>$200 per month</small></p>
                            <hr>
                            <p class="card-text">Take your segmentation to the next level! With annual access you can get unlimited reports and basic support from our Analyze360 experts.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Annual Access', price: '2400', sku: 'A360_ANNUAL_FULL_23', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'year'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div v-if="this.promoConfirm == 'LEADSCON_1000'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Premium Access</h5>
                            <h5 class="h2 mb-0"><strong><del>$6,000/yr</del></strong><br>
                                <strong><span class="text-success">$417/mo</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>$1000 discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Get Enterprise-grade features like advanced data science support and customization options like access to the API.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Premium Access', price: '5000', sku: 'LEADSCON_1000', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'year'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="this.promoConfirm == 'A360_PREMIUM_HALF_23'" class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Premium Access</h5>
                            <h5 class="h2 mb-0"><strong><del>$6,000/yr</del></strong><br>
                                <strong><span class="text-success">$250/mo</span></strong>
                            </h5>
                            <p class="text-center text-danger"><small><em>50% discount applied</em></small></p>
                            <hr>
                            <p class="card-text">Get Enterprise-grade features like advanced data science support and customization options like access to the API.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Premium Access', price: '3000', sku: 'A360_PREMIUM_HALF_23', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'year'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card card-body card-products text-center h-100 px-5">
                        <div class="card-body text-center">
                            <h5 class="card-title">Premium Access</h5>
                            <h5 class="h2 mb-0"><strong>$6,000</strong></h5>
                            <p class="mb-3"><small>per year,<br>$500 per month</small></p>
                            <hr>
                            <p class="card-text">Get Enterprise-grade features like advanced data science support and customization options like access to the API.</p>
                            <div class="card-footer">
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary" @click="$emit('purchaseItems', {title: 'Analyze360 2024 Premium Access', price: '6000', sku: 'A360_PREMIUM_FULL_23', mode: 'subscription', remaining: '0', prospects: '0', subscription: 'premium'})">Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SelectSubscription',
    props: {
        promoConfirm: ''
    },
    mounted() {
        if(this.promoConfirm == '360FREE') {
            this.$emit('freeItems', {title: 'Analyze360 2024 Single Report', price: '0', sku: 'A360_SNGL_FREE_23', mode: 'payment', remaining: '1', prospects: '1', subscription: 'single' });
        }
    }
}
</script>